<template>
    <div class="backgroundWrapper charm-bg">
        <div class="listToggle">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }"
                        @click="activateTab('thisweek')" data-toggle="tab" href="#thisweek" role="tab">This Week</div>
                </li>
                <li class="nav-item" @click="hideTimesBox">
                    <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }"
                        @click="activateTab('lastweek')" data-toggle="tab" href="#lastweek" role="tab">Last Week</div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisWeek">
                    <LuckyRewardsThisWeek />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastWeek">
                    <LuckyRewardsLastWeek />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LuckyRewardsThisWeek from './LuckyRewardsThisWeek.vue'
import LuckyRewardsLastWeek from './LuckyRewardsLastWeek.vue'
export default {
    name: 'LuckyRewards',
    components: {
        LuckyRewardsThisWeek,
        LuckyRewardsLastWeek,
    },
    data() {
        return {
            activeTab: 'thisweek',
            isLoadedThisWeek: false,
            isLoadedLastWeek: false
        };
    },
    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
            if (tabId === 'thisweek' && !this.isLoadedThisWeek) {
                this.isLoadedThisWeek = true
            }
            if (tabId === 'lastweek' && !this.isLoadedLastWeek) {
                this.isLoadedLastWeek = true
            }
        },
    },
    mounted() {
        this.isLoadedThisWeek = true
    }
}
</script>